<template lang="pug">
.odd-box(@click="placeBet($event.target)")
  .odd.center(:class="cssClass")
    template(v-if="['hdp','hdph','ou','ouh'].includes(mode)")
      //- .odd-point {{ details[mode][count][25] }}
      .odd-point {{ showOdds(mode.toUpperCase(), homeAway, details[mode][count][7], details[mode][count][25]) }}
        template(v-if="details[mode][count][7] == (homeAway == 2 ? 0 : homeAway)")
          template(v-if="details[mode][count][24] < 0")
            span.negetive ({{ details[mode][count][24] }})
          template(v-else-if="details[mode][count][24] > 0")
            span ({{ '+' + details[mode][count][24] }})
          template(v-else)
            span ({{ details[mode][count][24] }})
        template(v-else)
          template(v-if="details[mode][count][24] < 0")
            span ({{ '+' + details[mode][count][24] * -1 }})
          template(v-else-if="details[mode][count][24] > 0")
            span.negetive ({{ details[mode][count][24] * -1 }})
          template(v-else)
            span ({{ details[mode][count][24] }})
        span.giving(v-if="['hdp','hdph'].includes(mode)") {{ homeAway == 1 ? 'H' : 'A' }}
    .odd-value(:class="valueClass") {{ value }}
</template>

<script>
import naming from "@/library/_name";
import { EventBus } from "@/library/_event-bus.js";

export default {
  props: {
    details: {
      type: [Object, Array]
    },
    odds: {
      type: Array
    },
    idx: {
      type: String
    },
    pos: {
      type: String,
    },
    typ: {
      type: String
    },
    cls: {
      type: String
    },
    dataType: {
      type: String
    },
    mode: {
      type: String
    },
    count: {
      type: [Number, String]
    },
    homeAway: {
      type: String
    },
    label: {
      type: String
    }
  },
  data() {
    return {
      trigger: false,
      timer: null,
      old: null,
      dir: null,
      defStake: "",
      newPage: true
    };
  },
  computed: {
    menu0() {
      return this.$store.getters.menu0;
    },
    menu1() {
      return this.$store.getters.menu1;
    },
    menu2() {
      return this.$store.getters.menu2;
    },
    menu3() {
      return this.$store.getters.menu3;
    },
    betType() {
      return this.$store.state.layout.menu3;
    },
    id() {
      return this.odds[3];
    },
    value() {
      return this.odds[this.pos];
    },
    cssClass() {
      if (this.dir != null) {
        return this.dir;
      }
    },
    dv() {
      if (this.odds[parseInt(this.pos)]) {
        return parseFloat(this.odds[27]);
      } else {
        return 0;
      }
    },
    valueClass() {
      var result = [];
      if (this.cls) {
        result.push(this.cls);
      }
      if (!this.allowBet) {
        result.push("nb");
      }
      if (this.value < 0) {
        result.push("negative");
      }
      return result;
    },
    allowBet() {
      return this.odds[15] == 1;
    },
    pause() {
      return this.odds[14] == 1 || this.odds[21] == 1;
    },
    mixParlay() {
      return this.odds[13] == 1;
    }
  },
  watch: {
    dv(newVal, oldVal) {
      var nv = newVal;
      var ov = oldVal;
      if (nv == "" || nv == 0) {
        this.trigger = false;
        this.dir = null;
        return;
      } else {
        if (ov != nv) {
          this.trigger = true;
          if (nv < 0) {
            if (ov < nv) {
              this.dir = "odd-drop";
            } else {
              this.dir = "odd-rise";
            }
          } else {
            if (ov > nv) {
              this.dir = "odd-drop";
            } else {
              this.dir = "odd-rise";
            }
          }
          setTimeout(() => {
            this.trigger = false;
            this.dir = null;
          }, 10000);
        }
      }
      this.old = oldVal;
    },
    id(newVal, oldVal) {
      this.reset();
    },
    typ(newVal, oldVal) {
      this.reset();
    },
    betType(newVal, oldVal) {
      this.reset();
    },
    menu0() {
      this.reset();
    },
    menu1() {
      this.reset();
    },
    menu2() {
      this.reset();
    },
    menu3() {
      this.reset();
    }
  },
  methods: {
    reset() {
      this.trigger = false;
      this.old = null;
      this.dir = null;
    },
    showOdds(bet_type, home_away, giving, odds) {
      return naming.ballDisplayMMO1(odds, giving, home_away, bet_type, this);
    },
    placeBet(e) {
      $(".odd-value").removeClass("selected-odds");
      if (this.allowBet) {
        if (this.$store.state.layout.betting.defaultStake == "0") {
          this.defStake = this.$store.state.layout.betting.defaultStakeAmount;
        } else {
          this.defStake = 5;
        }
        if (this.betType != "parlay") {
          setTimeout(() => {
            $(e).addClass("selected-odds");
          }, 10);
          if (EventBus.betSingleMMO) {
            EventBus.betSingleMMO(this.odds, "MY", this.idx, this.value, this.betType, this.defStake, this.mixParlay, true, e, this.pos);
          }
        }
      }
    }
  }
};
</script>
